module.exports = __webpack_public_path__ + "static/media/wavy_right.eeef6a6a.svg";